module.exports = __webpack_public_path__ + "img/balance-question-mark.8647c564.png";